import {charcoal} from '../../sass/base/_exports.sass';

export const HamburgerMenuIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 10.6666H22V12H10V10.6666ZM10 15.3333H22V16.6666H10V15.3333ZM10 20H22V21.3333H10V20Z"
        fill={color}
      />
    </svg>
  );
};
